/**
 * Created by sunshine on 2016/12/27.
 */
/*eslint-disable*/
let apiLinks

// let domains = 'https://'
// 开发环境 dev http://yc.yonyou.com 360   账号为ycwyg56
// 正式环境 https://yc.yonyoucloud.com 17810 xc52rkw1
// B环境 wuyanguo 1219

// A环境是用正式的，B环境是用吴彦国的
// 正式环境
let enterpriseId = 17810
let yc = 'https://yc.yonyoucloud.com'
let portaltype = window.localStorage.portaltype

apiLinks = {
  // 查询南方水泥的
  materiaClass: yc + '/yuncai/jsonp/pubmaterialClass?enterpriseId=' + enterpriseId,
  // materiaClass: yc + '/yuncai/jsonp/materialClass?enterpriseId=' + enterpriseId,
  orgClass: yc + '/yuncai/org/getorgbydef?pageIndex=0&pageSize=100&org_type=2&org_types=0&enterprise_id=' + enterpriseId,
  // 南方水泥各链接
  southCement: {
    home: 'http://www.shanghaiwater.com/'
  },
  caslogout: '/yuncai/caslogout',
  // 注册页面
  register: yc + '/yuncai/privateportal#/pages/supplymgr/supplyapplyregister?purentid=' + enterpriseId + '&agree=1&ipuid=' + portaltype,
  // 进入工作台/注册
  enterWorkbench: yc + '/workbench/sso/login.jsp',
  // 供应商申请
  suppliersFor: yc + "/cpu-portal-fe/portalcas.html#/pages/supplymgr/addSupplyApply?purentid="+ enterpriseId +"&ipuid=" + portaltype +"&v="+Date.parse(new Date().toLocaleDateString()),
  // 首页左侧数据相关链接
  infoTable: {
    latest: [
      yc + '/yuncai/jsonp/supplierOffer/list?type=pp&bidType=allNotice&supEnterpriseIds=' + enterpriseId + '&status=4&pageIndex=0&pageSize=6',
      'latest2',
      'latest3'
    ],
    area: [
      yc + '/yuncai/jsonp/supplierOffer/list?type=pp&bidType=allNotice&supEnterpriseIds=' + enterpriseId + '&status=4&pageIndex=0&pageSize=6',
      'area2',
      'area3',
      'area4',
      'area5',
      'area6',
      'area7',
      'area8'
    ],
    type: [
      yc + '/yuncai/jsonp/supplierOffer/list?type=pp&bidType=allNotice&supEnterpriseIds=' + enterpriseId + '&status=4&pageIndex=0&pageSize=6',
      '2',
      '3',
      '4'
    ]
  },
  // 物资招标公告链接(之后封装成一个对象目前只有两个)
  purchasetableDate: [
    // 询价公告
    yc + '/yuncai/jsonp/supplierOffer/list?type=pp&bidType=purchase&supEnterpriseIds=' + enterpriseId + '&status=0&pageSize=10&pageIndex=0',
    // 招标公告
    yc + '/yuncai/jsonp/supplierOffer/list?type=pp&bidType=purchase&supEnterpriseIds=' + enterpriseId + '&status=4&pageSize=10&pageIndex=0',
    // 中标公告
    yc + '/yuncai/jsonp/supplierOffer/list?type=pp&bidType=purchase&supEnterpriseIds=' + enterpriseId + '&status=10&pageSize=10&pageIndex=0',
    // 竞价公告
    '',
    // 竞价性谈判
    ''
  ],
  // 物流招标公告链接
  logisticstableDate: [
    // 询价公告
    '',
    // 招标公告
    yc + '/yuncai/jsonp/supplierOffer/list?type=pp&bidType=logistics&supEnterpriseIds=' + enterpriseId + '&status=6&pageSize=10&pageIndex=0',
    // 中标公告
    yc + '/yuncai/jsonp/supplierOffer/list?type=pp&bidType=logistics&supEnterpriseIds=' + enterpriseId + '&status=7&pageSize=10&pageIndex=0',
    // 竞价公告
    '',
    // 竞价性谈判
    ''
  ],
  // 工程招标公告链接
  logisticsestableDate: [
    // 询价公告
    '',
    // 招标公告
    yc + '/yuncai/jsonp/supplierOffer/list?type=pp&bidType=logistics&supEnterpriseIds=' + enterpriseId + '&status=11&pageSize=10&pageIndex=0',
    // 中标公告
    yc + '/yuncai/jsonp/supplierOffer/list?type=pp&bidType=logistics&supEnterpriseIds=' + enterpriseId + '&status=13&pageSize=10&pageIndex=0'
  ],
  // 服务招标公告链接
  engineeringtableDate: [
    // 询价公告
    '',
    // 招标公告
    yc + '/yuncai/jsonp/supplierOffer/list?type=pp&bidType=logistics&supEnterpriseIds=' + enterpriseId + '&status=12&pageSize=10&pageIndex=0',
    // 中标公告
    yc + '/yuncai/jsonp/supplierOffer/list?type=pp&bidType=logistics&supEnterpriseIds=' + enterpriseId + '&status=14&pageSize=10&pageIndex=0'
  ],
  // 查看详情不同status跳转页面 bidDetails: cpu-fe-bid -> cpu-fe-tender
  details: {
    bidDoc: yc + '/cpu-fe-bid/dist/bidddocread/index.html?type=1&id=',
    bidDetails: yc + '/cpu-fe-tender/dist/supplyenlistshowother/index.html?show=1&id=',
    bidNotice: yc + '/cpu-portal-fe/portalcas.html#/pages/pricedecision/pricedecisionnotice_publish?id=',
    bidMsg: yc + '/cpu-fe-bid/dist/submitbidnotice/index.html?type=3&id=',
    inquiryDetails: yc + '/cpu-fe-tender/dist/inquirydetail/index.html?id=',
    company: yc + '/gwmanage/pages/notice/detail.html?id='
  },
  // 首页右侧数据相关链接 正式 xc52rkw1  B环境 kpd6im25 测试环境p6ochmd2
  notice: {
    company: '/gwmanage/pub/notices?appcode=cpu&tenantid=xc52rkw1&pageSize=6',
    bidding: yc + '/yuncai/jsonp/supplierOffer/list?type=pp&bidType=purchase&supEnterpriseIds=' + enterpriseId + '&status=10&pageSize=6&pageIndex=0',
    clarify: ''
  },
  // 联系我们页面
  contact: yc + '/cpu-project-def/ycctrl/projectdef/getBidCountInfo?enterpriseId=' + enterpriseId,
  // 是否已申请过供应商
  agreement: yc + '/cpu-supplymgr/supplyApply/isExistApply?purEntId=' + enterpriseId
}
export {apiLinks}



// WEBPACK FOOTER //
// ./src/api/links.js